/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Col_MaterialInputs */

const vi_confirm_return_col_material = /** @type {(inputs: Confirm_Return_Col_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VẬT TƯ / LÔ`)
};

/**

* @param {Confirm_Return_Col_MaterialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_col_material = /** @type {((inputs?: Confirm_Return_Col_MaterialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Col_MaterialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_col_material(inputs)
});